module.exports = __webpack_public_path__ + "img/ph_front.878f8528.jpg";